<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="m 15.025391,16.910156 a 1,1 0 0 0 -1,1 V 20.25 c -1.74e-4,0.887764 0.50508,1.704316 1.298828,2.101562 l 0.523437,0.261719 c 1.040822,0.520137 2.267772,0.520137 3.308594,0 l 0.521484,-0.261719 c 0.79457,-0.397024 1.300955,-1.213431 1.300782,-2.101562 v -2.339844 a 1,1 0 0 0 -1,-1 1,1 0 0 0 -1,1 V 20.25 c 2.6e-5,0.134667 -0.07293,0.252325 -0.19336,0.3125 l -0.523437,0.261719 c -0.479577,0.239662 -1.039955,0.239662 -1.519532,0 L 16.21875,20.5625 c -0.120482,-0.0602 -0.193386,-0.177963 -0.193359,-0.3125 v -2.339844 a 1,1 0 0 0 -1,-1 z"
        />
        <path
            fill="currentColor"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="m 17.498047,13 c -0.497347,0 -0.992962,0.115405 -1.449219,0.34375 l -3.085937,1.542969 c -0.590274,0.295952 -0.966242,0.904088 -0.964844,1.564453 a 1.0001,1.0001 0 0 0 0,0.002 c 0.0016,0.66019 0.379084,1.267184 0.970703,1.560547 l 3.085937,1.541015 c 0.912083,0.454887 1.988308,0.454887 2.900391,0 l 3.083984,-1.542968 c 0.591228,-0.294682 0.968751,-0.902248 0.96875,-1.5625 0,-0.659787 -0.376338,-1.269521 -0.966796,-1.564453 h -0.002 l -3.089843,-1.542969 v 0.002 C 18.492961,13.115405 17.995394,13 17.498047,13 Z m -0.554688,2.130859 c 0.350684,-0.175508 0.760644,-0.175508 1.111328,0 a 1.0001,1.0001 0 0 0 0.002,0.002 l 2.636718,1.316406 -2.630859,1.316406 c -0.3509,0.175006 -0.762173,0.174393 -1.113281,0 h -0.002 l -2.636719,-1.318359 2.632812,-1.314453 a 1.0001,1.0001 0 0 0 0,-0.002 z"
        />
        <path
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M22.0037 16.4484V18.2492"
        />
        <path
            fill="currentColor"
            d="m 5.9980469,2.9960938 c -1.6454662,0 -3.0019532,1.3564869 -3.0019531,3.0019531 V 19.001953 a 1,1 0 0 0 1,1 1,1 0 0 0 0.9999999,-1 V 5.9980469 c 0,-0.5645916 0.4373616,-1.0019531 1.0019532,-1.0019532 H 18.001953 c 0.564547,0 1,0.4373616 1,1.0019532 V 12 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 V 5.9980469 c 0,-1.6454662 -1.354549,-3.0019531 -3,-3.0019531 z"
        />
        <path
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M7.99792 3.99625V17.0017"
        />
        <path
            fill="currentColor"
            d="m 5.9980469,16.001953 c -1.6455265,0 -3.0019531,1.354549 -3.0019531,3 0,1.645451 1.3564869,3.001953 3.0019531,3.001953 H 12 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 H 5.9980469 c -0.5645916,0 -1.0019532,-0.437406 -1.0019532,-1.001953 0,-0.564547 0.4374219,-1 1.0019532,-1 h 4 a 1,1 0 0 0 1.0000001,-1 1,1 0 0 0 -1.0000001,-1 z"
        />
    </svg>
</template>
